var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Prop } from "vue-property-decorator";
import Row from "bootstrap-vue/es/components/layout/row";
import Col from "bootstrap-vue/es/components/layout/col";
import Breadcrumb from "bootstrap-vue/es/components/breadcrumb/breadcrumb";
import BreadcrumbItem from "bootstrap-vue/es/components/breadcrumb/breadcrumb-item";
var PageLinkList = /** @class */ (function (_super) {
    __extends(PageLinkList, _super);
    function PageLinkList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    __decorate([
        Prop({ type: Array, required: true })
    ], PageLinkList.prototype, "items", void 0);
    __decorate([
        Prop({ type: String, required: true })
    ], PageLinkList.prototype, "title", void 0);
    PageLinkList = __decorate([
        Component({
            name: "PageLinkList",
            components: {
                "b-row": Row,
                "b-col": Col,
                "b-breadcrumb": Breadcrumb,
                "b-breadcrumb-item": BreadcrumbItem
            }
        })
    ], PageLinkList);
    return PageLinkList;
}(Vue));
export default PageLinkList;
;



//////////////////
// WEBPACK FOOTER
// ./node_modules/ts-loader!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/Components/PageLinkList.vue
// module id = 890
// module chunks = 0